
import "./panel.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";


import { useState, useEffect, useTransition } from "react";

/* banco de dados */
import { db, auth } from "../../services/firebaseConnection";
import { collection, getDocs, getDoc, doc, where, query, limit, orderBy, onSnapshot } from "firebase/firestore";

/* navegação */
import { useNavigate } from "react-router-dom";

/* funções auxiliares */
import { statusAgentsPanel, formatTimestamp, dateDiffDias, expiryDate, db_basic } from "../../services/functions/functions.ts";

/* gráfico */
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid, LabelList } from "recharts";

/* agenda */
import AgendaPanel from "./agenda";


/* imagens */
import panel_agent from "../../assets/panel_agent.png";
import panel_graphics from "../../assets/panel_graphics.png";
import panel_payment from "../../assets/panel_payment.png";
import panel_config from "../../assets/panel_config.png";
import panel_schedule from "../../assets/panel_schedule.png";


/*
status dos agentes e ações:
  0	- cliente foi cadastrado - criar agente
  1	- agente foi criado mas não foi configurado - configurar agente
  2	- agente configurado mas pendente de ativação - ver detalhes
  3	- agente ativado - período de testes (7 dias)
  4	- agente ativado - cliente assinante
  5	- agente desativado (pedido do cliente) - criar agente
  6	- agente desativado - falta de pagamento - criar agente
  7	- agente desativado - uso interno - criar agente
*/


export default function Panel() {

    const [basic, setBasic] = useState(null);
    const [dadosBilling, setDadosBilling] = useState([]);
    const [difhrs, setDifhrs] = useState(0);
    const [dtConf, setDataConf] = useState(null);
    const [dtAtiv, setDataAtiv] = useState(null);

    const [chart, setChart] = useState([]);
    const [agenda, setAgenda] = useState([]);
    const [idGptMaker, setIdGptMaker] = useState("");

    const [client, setClient] = useState([]);

    const navigate = useNavigate();

    const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const [loaded1, setLoaded1] = useState(false);
    const [loaded2, setLoaded2] = useState(false);
    const [loaded3, setLoaded3] = useState(false);
    const [loaded4, setLoaded4] = useState(false);
    const [loaded5, setLoaded5] = useState(false);


    useEffect(() => { window.scrollTo(0, 0); }, []);

    useEffect(() => {

        const loadBasic = async () => {

            const uid = auth.currentUser.uid;
            const bbd = await db_basic(uid);
            setBasic(bbd);
            setLoaded3(true);
        };

        loadBasic();

    }, []);


    useEffect(() => {

        if(!basic?.agent) return;

        const aid = basic.agent.id;
        const ast = basic.agent.status;
        
        if(!(ast === 3 || ast === 4)) return;

        const logsRef = collection(db, "calendar_logs");
        const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"));

        const unsubscribe = onSnapshot(q, (snapshot) => {

            try {

                const docs = snapshot.docs;
                if (!docs || docs.length === 0) {
                    setAgenda([]);
                    return;
                }

                //transformar logs DESC → ASC
                const brutoDesc = docs.map(d => d.data());
                const bruto = [...brutoDesc].reverse();

                const processado = [];
                const usado = new Set();

                for (let i = 0; i < bruto.length; i++) {
                    if (usado.has(i)) continue;

                    const atual = bruto[i];
                    const timestampAtual = atual.date?.toDate ? atual.date.toDate().getTime() : 0;

                    if (atual.action === "CANCEL") {
                        for (let j = i + 1; j < bruto.length; j++) {
                            if (usado.has(j)) continue;

                            const prox = bruto[j];
                            const timestampProx = prox.date?.toDate ? prox.date.toDate().getTime() : 0;

                            const mesmoEmail = prox.email === atual.email;
                            const intervalo = Math.abs(timestampAtual - timestampProx);

                            if (prox.action === "ADD" && mesmoEmail && intervalo <= 30 * 60 * 1000) {

                                usado.add(i);
                                usado.add(j);
                                processado.push({dia: prox.dia.split('/').join('.'), hora: prox.hora, scheduledAt: prox.date?.toDate ? prox.date.toDate() : prox.date, nome: prox.nome || "", telefone: prox.telefone || "", action: "REAGENDADO", atendimento: prox.atendimento});
                                break;

                            }
                        }
                    }

                    if (!usado.has(i)) {
                        processado.push({dia: (atual.dia || "").split('/').join('.'), hora: atual.hora, scheduledAt: atual.date?.toDate ? atual.date.toDate() : atual.date, nome: atual.nome || "", telefone: atual.telefone || "", action: atual.action === "ADD" ? "AGENDADO" : "CANCELADO", atendimento: atual.atendimento});
                    }
                }

                //pegar últimos 4 registros (mais recentes)
                const final = processado.slice(-4);
                setAgenda(final);

            } catch(erro) {
                console.error("onSnapshot processing error:", erro);
            }
        });

        return () => unsubscribe();

    }, [basic]);


    useEffect(() => {

        if(!basic?.agent) return;

        const sts = basic.agent.status;

        const run = async () => {

            //1️. AGENTE
            (async () => {
                await wait(500);
                await load_agente();
                setLoaded1(true);
            })();

            //2. CHART
            if(sts === 3 || sts === 4) {
                (async () => {
                    await wait(1000);
                    await create_chart();
                    setLoaded2(true);
                })();
            }

            //3. BILLING
            if(sts === 4) {
                (async () => {
                    await wait(500);
                    await load_payments();
                    setLoaded4(true);
                })();
            }

            //5. AGENDA FUTURA
            if(sts === 3 || sts === 4) {
                (async () => {
                    await wait(1000);
                    await getNextSchedules();
                    setLoaded5(true);
                })();
            }

        };

        run();

    }, [basic]);


    async function load_agente() {

        let sts = basic.agent.status;
        let pla = basic.agent.plano;
        
        try {

            if(sts > 2) {

                let rmo = "";
                switch(pla.substring(0, 3)) {
                    case "CMD": 
                        rmo = "medical_";
                        break;
                    case "EST":
                        rmo = "aesthetic";  
                        break;
                }
                console.log(rmo);
                const agentcontentdb = collection(db, rmo);
                const agentcontentquery = query(agentcontentdb, where("id_agent", "==", basic.agent.id), limit(1));

                const agentcontentdoc = await getDocs(agentcontentquery);
                setDataConf(agentcontentdoc.docs[0].data().data_criacao);
                console.log(agentcontentdoc.docs[0].data().data_criacao);
                if(sts === 3) {
                    setDifhrs(dateDiffDias(new Date(agentcontentdoc.docs[0].data().data_criacao.toDate()), new Date()).horas);
                }

                if(sts === 3 || sts === 4) {
                    setDataAtiv(agentcontentdoc.docs[0].data().data_criacao);
                } else if(sts > 4) {
                    setDataAtiv(agentcontentdoc.docs[0].data().data_encerramento);
                }
                
            }                    
                
        }
        catch(erro) {
            alert("busca agente " + erro);
        }        

    }
    

    async function load_payments() {

        let aid = basic.agent.id;
        let cod = basic.agent.plano;

        try {

            const billingsdb = collection(db, "billings");
            const billingsquery = query(billingsdb, where("id_agent", "==", aid), orderBy("data_criacao", "desc"), limit(1));

            const billingsdoc = await getDocs(billingsquery);

            const billing = billingsdoc.docs[0].data();

            let tipoUltimaParcela = null;

            //verifica a regularidade de pagamento
            const hoje = new Date();
            let atrasado = false;

            if(Array.isArray(billing.parcelas)) {

                atrasado = billing.parcelas.some(parcela => {
                
                    const vencimento = parcela.vencimento?.toDate ? parcela.vencimento.toDate() : new Date(parcela.vencimento);
                    return parcela.status === "PENDING" && vencimento < hoje;
                    
                });

                const ultimaParcela = billing.parcelas[billing.parcelas.length - 1];
                tipoUltimaParcela = ultimaParcela?.tipo ?? null;

            }

            billingsdoc.forEach(docSnap => {const billing = docSnap.data();
            
            if (!Array.isArray(billing.parcelas)) return;

                const temAtraso = billing.parcelas.some(parcela => {const vencimento = parcela.vencimento?.toDate ? parcela.vencimento.toDate() : new Date(parcela.vencimento);
                    return parcela.status === "PENDING" && vencimento < hoje;
                });

                if(temAtraso) atrasado = true;

            });

            //verifica o plano
            const plansdb = collection(db, "plans");
            const plansquery = query(plansdb, where("codigo", "==", cod), limit(1));

            const plansdoc = await getDocs(plansquery);

            const dad = {assinatura: formatTimestamp(billingsdoc.docs[0].data().data_criacao), pagamento: tipoUltimaParcela, vencimento: billingsdoc.docs[0].data().dia_vencimento, plano: plansdoc.docs[0].data().ramo, valor: plansdoc.docs[0].data().valor.toFixed(2), situacao: atrasado};
            setDadosBilling(dad);

        }
        catch(erro) {
            alert("busca billings " + erro);
        }

    }



    function execute_agent() {

        let sts = basic.agent.status;
        
        if(sts === 1) {
            switch(basic.agent.plano.substring(0, 3)) {

                case "CMD":
                    navigate("/medical_");
                    break;
                case "EST":
                    navigate("/aesthetic");
                    break;
            }

        } else if(sts === 3) {
            navigate("/billing");
        } else {
            navigate("/agent");
        }

    }

    
    async function create_chart() {
     
        try {
            
            let aid = basic.agent.id;
            let ast = basic.agent.status;

            const tel = basic.agent.telefone;
            const dta = basic.agent.data_criacao.toDate();
            const start_date = dta.toISOString().split("T")[0];

            //busca o id do agente do gptmaker
            const telephonesdb = collection(db, "telephones");
            const telephonequery = query(telephonesdb, where("telefone", "==", tel), limit(1));
            const telephonedoc = await getDocs(telephonequery);
            
            if (telephonedoc.empty) {
                throw new Error("Telefone não encontrado");
            }
        
            const idg = telephonedoc.docs[0].data().id_gptmaker;

            wait(500);

            const resGptMaker = await fetch("https://gptmaker-services-712108985873.southamerica-east1.run.app/dashs1",
                { method: "POST", headers: { "Content-Type": "application/json" },
                  body: JSON.stringify({
                    agent_id: idg,
                    start_date: start_date,
                    })
                });
           
            const resultGptMaker = await resGptMaker.json();
            if(resultGptMaker.error) {
                return;
            }

            const resumo = resultGptMaker.resumo;

            let chart = [];

            if(ast == 3) {

                const diasResumo = resumo.por_dia || {};
                const dias_map = Object.keys(diasResumo).reduce((acc, key) => {acc[key] = diasResumo[key]; return acc;}, {});

                for(let i = 0; i < 7; i++) {

                    const dia = new Date(dta);
                    dia.setDate(dia.getDate() + i);

                    const yyyy = dia.getFullYear();
                    const mm = String(dia.getMonth() + 1).padStart(2, '0');
                    const dd = String(dia.getDate()).padStart(2, '0');

                    const key = `${yyyy}-${mm}-${dd}`;
                    const dados = dias_map[key] || { resolvidos: 0, nao_resolvidos: 0 };

                    chart.push({dia: key, resolvidos: dados.resolvidos, nconcluido: dados.nao_resolvidos, concluido: dados.resolvidos, total: dados.resolvidos + dados.nao_resolvidos, rotulo: `dia ${i + 1}`});
                }
            }

            if(ast == 4) {

                const mesesResumo = resumo.por_mes || {};
                const meses_map = Object.keys(mesesResumo).reduce((acc, key) => {acc[key] = mesesResumo[key]; return acc;}, {});

                for(let i = 0; i < 7; i++) {

                    const mes = new Date(dta);
                    mes.setMonth(mes.getMonth() + i);

                    const yyyy = mes.getFullYear();
                    const yy = String(yyyy).slice(-2);
                    const mm = String(mes.getMonth() + 1).padStart(2, '0');

                    const key = `${yyyy}-${mm}`;
                    const dados = meses_map[key] || { resolvidos: 0, nao_resolvidos: 0 };

                    let nomeMes = mes.toLocaleDateString("pt-BR", { month: "short" });
                    nomeMes = nomeMes.replace(".", ""); // remove ponto (fev.)
                    nomeMes = nomeMes.charAt(0).toUpperCase() + nomeMes.slice(1);

                    const rotulo = `${nomeMes}.${yy}`;

                    chart.push({mes: key, resolvidos: dados.resolvidos, nconcluido: dados.nao_resolvidos, concluido: dados.resolvidos, total: dados.resolvidos + dados.nao_resolvidos, rotulo: rotulo});
                }
            }

            setChart(chart);
            
        } catch (erro) {
            alert("Erro ao montar gráfico: " + erro.message);
        }
        
    }

    
    async function getNextSchedules() {

        try {

            let aid = basic.agent.id;

            const logsRef = collection(db, "calendar_logs");
            const q = query(logsRef, where("id_agent", "==", aid), orderBy("date", "desc"), limit(20));
            const logsSnap = await getDocs(q);

            if(logsSnap.empty) {
                setAgenda([]);
                return [];
            }

            //bruto DESC (mais novo → mais antigo)
            const brutoDesc = [];
            logsSnap.forEach((logDoc) => { const log = logDoc.data();
            brutoDesc.push({dia: log.dia.split('/').join('.'), hora: log.hora, scheduledAt: log.date?.toDate ? log.date.toDate() : log.date, nome: log.nome, telefone: log.telefone, email: log.email, action: log.action, timestamp: log.date?.toDate ? log.date.toDate().getTime() : 0, atendimento: log.atendimento});    
            });

            //transformar para ASC (mais antigo → mais novo)
            const bruto = [...brutoDesc].reverse();

            const processado = [];
            const usado = new Set();

            for (let i = 0; i < bruto.length; i++) {
                if (usado.has(i)) continue;

            const atual = bruto[i];

            //se for CANCEL → procurar ADD DEPOIS (em ordem cronológica)
            if (atual.action === "CANCEL") {
                for (let j = i + 1; j < bruto.length; j++) {
                    const prox = bruto[j];
                    if (usado.has(j)) continue;

                    const mesmoEmail = prox.email === atual.email;
                    const intervalo = Math.abs(atual.timestamp - prox.timestamp);

                    if (prox.action === "ADD" && mesmoEmail && intervalo <= 30 * 60 * 1000) {
                        
                        usado.add(i);
                        usado.add(j);
                        processado.push({dia: prox.dia, hora: prox.hora, scheduledAt: prox.scheduledAt, nome: prox.nome, telefone: prox.telefone, action: "REAGENDADO", atendimento: prox.atendimento});
                        break;
                        
                    }
                }
            }

            if (!usado.has(i)) {
                processado.push({dia: atual.dia, hora: atual.hora, scheduledAt: atual.scheduledAt, nome: atual.nome, telefone: atual.telefone, action: atual.action === "ADD" ? "AGENDADO" : "CANCELADO", atendimento: atual.atendimento});
            }
        }

        // processado está ASC → pegar últimos 4
        const final = processado.slice(-4);

        // ordenar para exibir: antigo→1 ... novo→4
        setAgenda(final);

        } catch(erro) {
            console.error("getNextSchedules: ", erro);
            setAgenda([]);
            return [];
        }
    }

    const panel = statusAgentsPanel(basic?.agent?.status ?? -1);
    
    return(

        <div className="context">

            <Header access={1}></Header>

            <div className="content">
                <div className="ft_topico">Painel do cliente</div>
                <div className="ft_descricao">Esse é o Painel do cliente, aqui você pode configurar seu agente, ver a peformance de atendimento dele, acompanhar seus pagamentos de mensalidade e alterar seus dados pessoais quando precisar.</div>
                <div className="space"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_agent}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configure seu agente</div>
                                <span className="panel_box_contentaviso">Aqui é onde você cria, modifica e confere o status do seu agente.</span>
                                
                                <div className="panel_box_infos">
                                { !loaded1 ? (<><span className="panel_box_contentinfo_load">carregando ...</span></>) : (
                                    <>                           
                                    <span className="panel_box_contentitem">Nome do Agente:<span className="panel_box_contentresult">&nbsp;{ basic.agent.nome }</span></span>
                                    <span className="panel_box_contentitem">Data de Criação:<span className="panel_box_contentresult">&nbsp;{ formatTimestamp(basic.agent.data_criacao) }</span></span>
                                    <span className="panel_box_contentitem">Número do Agente:<span className="panel_box_contentresult">&nbsp;{ basic.agent.telefone }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status:<span className="panel_box_contentresult">&nbsp;{panel?.[0]?.textStatus}</span></span>
                                    <span className="panel_box_contentitem">Data da Configuração<span className="panel_box_contentresult">&nbsp;{ dtConf === null ? "" : formatTimestamp(dtConf) }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">{basic.agent.status > 4 ? "Data de Desativação:" : "Data de Ativação:"}<span className="panel_box_contentresult">&nbsp;{ dtAtiv === null ? "" : formatTimestamp(dtAtiv) }</span></span>
                                    </>)}
                                </div>

                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt1" className={!loaded1 ? "button_disabled_form" : panel?.[0]?.classButton} onClick={ execute_agent } disabled={!loaded1}>{panel?.[0]?.textButton}</button>
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_schedule}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Agenda</div>
                                <span className="panel_box_contentaviso">Visualize todos os seus compromissos, tudo o que seus clientes agenadaram com você.</span>
                                { panel?.[1]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <AgendaPanel agenda={agenda} agentStatus={basic.agent.status}/>
                                    </>
                                    )}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[1].classButton} onClick={ (e)=> navigate(basic.agent.status === 3 ? "/billing" : "/schedule") } disabled={!loaded2}>VER AGENDA</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[1]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_graphics}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Performance do agente</div>
                                <span className="panel_box_contentaviso">Verifique o desempenho do seu agente com base na produtividade de atendimentos.</span>
                                { panel?.[2]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentchart">
                                    { !loaded2 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                      <ResponsiveContainer>
                                        <BarChart margin={{top: 20}} data={chart}>
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis dataKey="rotulo" tick={{fontSize: 10}} />
                                        <YAxis hide={true} />
                                        <Tooltip />
                                        <Legend wrapperStyle={{fontSize: 11}} formatter={(value, entry) => {if (value === 'concluido') return 'Resolvido'; if (value === 'nconcluido') return 'Não Resolvido'; return value;}} />
                                        <Bar dataKey="concluido" stackId="a" fill="green" />
                                        <Bar dataKey="nconcluido" stackId="a" fill="red">
                                        <LabelList
                                            dataKey="nconcluido"
                                            position="top"
                                            content={(props) => {
                                            const { x, y, width, value, index } = props;
                                            const total = chart[index].concluido + chart[index].nconcluido;
                                            return (<text x={x + width / 2} y={y - 5} textAnchor="middle" fill="black" fontSize={12}>{total}</text>);
                                            }}
                                        />
                                        </Bar>
                                        </BarChart>
                                    </ResponsiveContainer>
                                    </>)}
                                </div>
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt2" className={!loaded2 ? "button_disabled_form" : panel[2].classButton} onClick={ (e)=> navigate(basic.agent.status === 3 ? "/billing" : "/performance") } disabled={!loaded2}>VER MAIS</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[2]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_payment}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Planos e pagamentos</div>
                                <span className="panel_box_contentaviso">Acompanhe o período de testes do seu agente, bem como o pagamento das mensalidades.</span>
                                { panel?.[3]?.viewPanel ? (
                                <>
                                <div className="panel_box_contentpayment">

                                { basic.agent.status === 3 && (
                                <>
                                    { !loaded1 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>    
                                    <span className="panel_box_contentpayment_title">Período de testes gratuíto</span>
                                    <div className="panel_box_contentpayment_frame">
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#00B050", height: difhrs >= 24 ? "100%" : (difhrs * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 24 ? "4px" : "0px", borderTopRightRadius: difhrs >= 24 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 1</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#66C266", height: difhrs >= 48 ? "100%" : ((difhrs - 24) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 48 ? "4px" : "0px", borderTopRightRadius: difhrs >= 48 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 2</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#B7D77A", height: difhrs >= 72 ? "100%" : ((difhrs - 48) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 72 ? "4px" : "0px", borderTopRightRadius: difhrs >= 72 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 3</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#FFD966", height: difhrs >= 96 ? "100%" : ((difhrs - 72) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 96 ? "4px" : "0px", borderTopRightRadius: difhrs >= 96 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 4</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#F4B183", height: difhrs >= 120 ? "100%" : ((difhrs - 96) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 120 ? "4px" : "0px", borderTopRightRadius: difhrs >= 120 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 5</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#E06666", height: difhrs >= 144 ? "100%" : ((difhrs - 120) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 144 ? "4px" : "0px", borderTopRightRadius: difhrs >= 144 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 6</div>
                                        </div>
                                        <div className="panel_box_contentpayment_column">
                                            <div className="panel_box_contentpayment_percent">
                                                <div className="panel_box_contentpayment_border"><div className="panel_box_contentpayment_value" style={{backgroundColor: "#C00000", height: difhrs >= 168 ? "100%" : ((difhrs - 144) * 4.16666).toString() + "%", borderTopLeftRadius: difhrs >= 168 ? "4px" : "0px", borderTopRightRadius: difhrs >= 168 ? "4px" : "0px"}}></div></div>
                                            </div>
                                            <div className="panel_box_contentpayment_day">dia 7</div>
                                        </div>
                                    </div>
                                    </>
                                    }
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt3a" className={!loaded1 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded1} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                { basic.agent.status === 4 && (
                                <>
                                    { !loaded4 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : 
                                    <>
                                    <span className="panel_box_contentitem">Assinante desde:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.assinatura }</span></span>
                                    <span className="panel_box_contentitem">Forma de Pagamento:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.pagamento }</span></span>
                                    <span className="panel_box_contentitem">Vencimento (dia) :<span className="panel_box_contentresult">&nbsp;{ dadosBilling.vencimento }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Plano:<span className="panel_box_contentresult">&nbsp;{ dadosBilling.plano }</span></span>
                                    <span className="panel_box_contentitem">Valor do Plano:<span className="panel_box_contentresult">&nbsp;{ "R$ " + dadosBilling.valor }</span></span>
                                    <span className="panel_box_contentspace">
                                        <span className="panel_box_contentline"></span>
                                    </span>
                                    <span className="panel_box_contentitem">Status Assinatura:<span className="panel_box_contentresult" style={{color: dadosBilling.situacao ? "red" : "green"}}>&nbsp;{ dadosBilling.situacao ? "Pagamento em atraso" : "Pagamentos em dia" }</span></span>
                                    <span className="panel_box_contentspace"></span>
                                    
                                    </>
                                    }
                                <button type="button" name="bt3a" className={!loaded4 ? "button_disabled_form" : panel[3].classButton} disabled={!loaded4} onClick={ (e)=> navigate("/billing") }>{panel[3].textButton}</button>
                                </>
                                )}

                                </div>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[3]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}

                            </div>
                        </div>
                    </div>


                    <div className="panel_box_space"></div>
                </div>

                <div className="space-mobile"></div>

                <div className="panel_box">
                    <div className="panel_box_space-mobile2"></div>
                    <div className="panel_box_context">
                        <div className="panel_image_item"><img className="panel_image_item_content" src={panel_config}></img></div>
                        <div className="panel_box_content">
                            <div className="panel_box_contentborder">
                                <div className="panel_box_contenttitle">Configurações</div>
                                <span className="panel_box_contentaviso">Altere seus dados cadastrais, sua senha e demais configurações.</span>
                                { panel?.[4]?.viewPanel ? (
                                <>
                                    { !loaded3 ? (<><span className="panel_box_contentchart_load">carregando ...</span></>) : (
                                    <>
                                    <div className="panel_box_contentconfigure">
                                        <span className="panel_box_contentitem">Empresa:</span>
                                        <span className="panel_box_contentresult">{ basic.client.empresa }</span>
                                        <span className="panel_box_contentitem">Responsável:</span>
                                        <span className="panel_box_contentresult">{ basic.client.responsavel }</span>
                                        <span className="panel_box_contentspace">
                                            <span className="panel_box_contentline"></span>
                                        </span>
                                        <span className="panel_box_contentitem">Email:<span className="panel_box_contentresult">&nbsp;{ basic.client.email }</span></span>
                                        <span className="panel_box_contentitem">Data de Cadastro:<span className="panel_box_contentresult">&nbsp;{ formatTimestamp(basic.client.data_criacao) }</span></span>
                                    </div>                            
                                    </>
                                    )}
                                <span className="panel_box_contentspace"></span>
                                <button type="button" name="bt4" className={!loaded3 ? "button_disabled_form" : panel[4].classButton} onClick={ (e)=> navigate("/account") } disabled={!loaded3}>{panel[4].textButton}</button>
                                </>
                                ) : (<><span className="panel_box_content_status">{panel?.[4]?.textPanel}</span><span className="panel_box_contentconfigure_space"></span></>)}
                            </div>
                        </div>
                    </div>

                    <div className="panel_box_space"></div>

                    <div className="panel_box_context">
                        <div className="panel_image_item"></div>
                        <div className="panel_box_content"></div>
                    </div>

                    <div className="panel_box_space-mobile2"></div>
                </div>

                <div className="space"></div>
                <div className="space"></div>
                <div className="space"></div>

            </div>

            <Footer access={1}></Footer>

        </div>

    )
}